<template>
    <div>
        <OcorrenciaInfo :idOcorrencia="idOcorrencia" @setActionCard="setActionCard"
                        :isFinalizado="ocorrencia.flFinalizado" />

        <div class="container-fluid">
            <div class="row mt-3" style="padding-left: 13px;padding-right: 13px">
                <div class="col-7">
                    <div class="flex-grow-1  ">
                        <InputSearch v-model="filtro_text" placeholder="Pesquise pelo nome ou e-mail..." @updateSearch="reloadGrid" />
                    </div>
                    <DataTable v-if="!loading" :url_ajax="url_cortesias" :customHeightPaginate="sizeDatatableDinamicPG"
                               :customHeight="sizeDatatableDinamic" :ajax_set_result="setTable" @grid_refreshed="gridRefreshed"
                               :refresh="refresh_grid" :filtros="filtro" method="GET" :qtd_registros_por_pagina="20"
                               :is_table="true" :footer_fixed="true" :headers="headers" :pBtnsSlot="true" :is_modal="true"
                               :is_NotLoading="NotLoading" styleBotton="bottom:-5px" :request_api="'comercial'">

                        <template v-slot:BtnSlot="item">
                            <button type="button" class="btn-visualiza-cortesia"
                                    @click="openCortesia(item.row.idCortesia, rowIndex)" v-if="item.row.idCortesia > 0"
                                    :class="{ 'selected': selectedButtonIndices[item.index] === item.row.idCortesia }">
                                <i class="far fa-eye"></i><span class="btn-span-text" :style="dNoneDinamic">
                                    {{ item.row.idSolicitacaoContato > 0 ? 'Solicitação de Contato' : 'Visualizar Cortesia' }}
                                </span>
                            </button>
                            <button type="button" class="btn-grid-editar-lista btn-Ligar"
                                    @click="func_crud(0, item.row.idInstituicao, item.row.idPessoa, 'SederCortesia')" v-else>
                                <i class="fas fa-address-card"></i><span class="btn-span-text" :style="dNoneDinamic">
                                    Gerar
                                    Cortesia
                                </span>
                            </button>
                        </template>

                    </DataTable>
                </div>
                <div class="col-5">
                    <div class="container-fluid" v-if="idCortesia_Selected > 0">
                        <label class="form-label" style="color: #AB0000"> Dados da Cortesia Gerada</label>
                        <Card_Title class_color="bg-color-4">
                            <template v-slot:context>
                                <div class="row">
                                    <div class="col-8">
                                        <label class="form-label m-0">Login</label>
                                        <h5 class="card-dados" style="font-size: 14px;">
                                            {{ Cortesia.dsLoginCortesiaGerado }}
                                        </h5>
                                    </div>
                                    <div class="col">
                                        <label class="form-label m-0"> Por</label>
                                        <h5 class="card-dados">
                                            <span style="color: #AB0000;font-size: 14px;">
                                                {{
                                                    Cortesia.dsLoginGerouCortesia
                                                }}
                                            </span> <span style="font-size: 14px;">em: {{ Cortesia.dtGeracao }}</span>
                                        </h5>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-8">
                                        <label class="form-label m-0"> Último Acesso: </label>
                                        <h5 class="card-dados" style="font-size: 14px;">{{ Cortesia.dtUltimoAcesso }}</h5>
                                    </div>
                                    <div class="col">
                                        <label class="form-label m-0">Quantidade Acessos:</label>
                                        <h5 class="card-dados" style="font-size: 14px;">{{ Cortesia.qtdUtilizacoes }}</h5>
                                    </div>
                                </div>

                            </template>
                        </Card_Title>

                        <div class="row col">
                            <div class="col">
                                <DateInput v-model="Cortesia.dtVigencia" class="col-12" :customWidth="customWidthDate"
                                           dateFormat="DD/MM/YYYY" />
                            </div>
                            <div class="row mt-2" style="padding-left: 14px;padding-right: 0px;">
                                <button class="col btn-grid-editar-lista btn-Ligar"
                                        @click="func_crudBtn('AlterarVigencia')">
                                    <i class='fa fa-cogs pe-2'></i>Alterar
                                    Vigência
                                </button>
                                <button class="col btn-grid-editar-lista btn-Ligar" @click="func_crudBtn('AlterarSenha')">
                                    <i class='fa fa-lock pe-2'></i>Alterar Senha e
                                    Reenviar
                                </button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <modal-warper target="ModalConfirmacao_alterar_Senha" :show="isOpenModalConfirmacaoAlterarSenha"
                      @close="(isOpenModalConfirmacaoAlterarSenha = false)">
            <ModalConfirmacao id="alterar_Senha" :title="'Alterar Senha'" :show="isOpenModalConfirmacaoAlterarSenha"
                              :description="''" :red="'Deseja realmente alterar a Senha e reenviar o e-mail?'" :action="'Alterar Senha'"
                              @actionReturn="altera_senha" :isDelete="false" />
        </modal-warper>

        <modal-warper target="ModalConfirmacao_set_cortesia" :show="isOpenModalConfirmacaoSetCortesia"
                      @close="(isOpenModalConfirmacaoSetCortesia = false)">
            <ModalConfirmacao id="set_cortesia" :title="'Cortesia'" :show="isOpenModalConfirmacaoSetCortesia"
                              :description="''" :red="'Deseja realmente Gerar a Cortesia?'" :action="'Gerar Cortesia'"
                              @actionReturn="action_cortesia" :isDelete="false" />
        </modal-warper>

        <modal-warper target="ModalConfirmacao_alterar_Vigência" :show="isOpenModalConfirmacaoAlterarVigencia"
                      @close="(isOpenModalConfirmacaoAlterarVigencia = false)">
            <ModalConfirmacao id="alterar_Vigência" :title="'Alterar Vigência'"
                              :show="isOpenModalConfirmacaoAlterarVigencia" :description="''"
                              :red="'Deseja realmente alterar a Vigência?'" :action="'Alterar Vigência'" @actionReturn="altera_vigencia"
                              :isDelete="false" />
        </modal-warper>

    </div>
</template>

<script>

    import axios from 'axios';
    import DataTable from '@/components/App/Datatable.vue'
    import ModalWarper from '@/components/App/ModalWarper.vue'
    import OcorrenciaInfo from '../../../../components/Tickets/Ocorrencia/Ocorrencia_Info.vue'
    import Card_Title from '@/components/App/Card_Title.vue';
    import DateInput from "@/components/App/DateInput.vue";
    import ModalConfirmacao from "@/components/App/ModalConfirmacao.vue";
    import $ from 'jquery';
    import InputSearch from './../../../../components/App/Input_Search.vue'

    export default {
        name: 'Agendamento',
        components: {
            DataTable,
            ModalWarper,
            OcorrenciaInfo,
            Card_Title,
            DateInput,
            ModalConfirmacao,
            InputSearch
        },
        props: {
            idOcorrencia: {
                type: Number,
                default: 0
            },
            idModulo: {
                type: Number,
                default: 0
            },
        },
        data() {
            return {
                idCortesia_Selected: 0,
                Cortesia: {},
                idInstituicao: 0,
                loading: true,
                url_cortesias: '',
                refresh_grid: false,
                showErrorMessage: false,
                ocorrencia: {},
                filtro_text: '',
                filtro: [
                    { active: true },
                ],
                headers: [
                    { class: 'col-2', name: 'nmPessoa', text: 'Nome', order: 0 },
                    { class: 'col-2 text-break', name: 'dsEmail', text: 'E-mail', order: 0 },
                    { class: 'col-2 text-center', name: 'dtGeracao', text: 'Geração', order: 0 },
                    { class: 'col-2 text-center', name: 'dtUltimoLogin', text: 'Acessou', order: 0 },
                    { class: 'col max_w_200', name: 'btns', text: '', actions: true, }
                ],                
                NotLoading: false,
                customWidthDate: '',
                isOpenModalConfirmacaoAlterarVigencia: false,
                isOpenModalConfirmacaoAlterarSenha: false,
                isOpenModalConfirmacaoSetCortesia: false,
                selectedButtonIndices: {},
                dNoneDinamic: '',
                sizeDatatableDinamic: '',
                sizeDatatableDinamicPG: '',

                setCortesiaCrud: {
                    idCortesia: 0,
                    idInstituicao: 0,
                    idPessoa: 0,
                    rowIndex: 0
                }

            }
        },
        updated() {
            this.updateSizeDinamic();
        },
        methods: {
            getOcorrencia() {
                let $this = this;

                axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Ocorrencia/GetId?id=' + $this.idOcorrencia, {
                    headers: $this.$api.getTokenComercial(),
                    params: ''
                }).then(response => {
                    $this.ocorrencia = response.data.data;
                })
            },
            saveDate() {

            },
            func_crudBtn(tpAlteracao) {
                if (tpAlteracao == 'AlterarVigencia') {

                    this.isOpenModalConfirmacaoAlterarVigencia = true;
                } else if (tpAlteracao == 'AlterarSenha') {

                    this.isOpenModalConfirmacaoAlterarSenha = true;
                }
            },
            func_crud(idCortesia, idInstituicao, idPessoa, tpAlteracao) {

                this.setCortesiaCrud.idCortesia = idCortesia;
                this.setCortesiaCrud.idInstituicao = idInstituicao;
                this.setCortesiaCrud.idPessoa = idPessoa;

                if (tpAlteracao == 'SederCortesia') {

                    this.isOpenModalConfirmacaoSetCortesia = true;
                }

            },
            updateSizeDinamic() {
                if (window.innerWidth <= 1400) {
                    this.dNoneDinamic = 'display:none'
                    this.customWidthDate = 'width:102%'
                    this.sizeDatatableDinamic = 'margin-top: 0px !important;min-height: calc(100vh - 18rem);max-height: calc(100vh - 18rem);'
                    this.sizeDatatableDinamicPG = 'margin-top: 0px !important;max-height: calc(100vh - 20rem);margin-right:2px;min-height: calc(100vh - 20rem)'

                } else if (window.innerWidth >= 3500) {
                    this.customWidthDate = 'width:107%'
                    this.dNoneDinamic = ''
                    this.sizeDatatableDinamic = 'margin-top: 0px !important;min-height: calc(100vh - 20rem);max-height: calc(100vh - 20rem);'

                } else {
                    this.customWidthDate = 'width:104%'
                    this.dNoneDinamic = ''
                    this.sizeDatatableDinamic = 'margin-top: 0px !important;min-height: calc(100vh - 22.4rem);max-height: calc(100vh - 22.4rem);'
                    this.sizeDatatableDinamicPG = 'margin-top: 0px !important;max-height: calc(100vh - 25.8rem);margin-right:2px;min-height: calc(100vh - 25.8rem)'


                }
            },
            getDadosOcorrencia() {
                let $this = this;

                axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Ocorrencia/GetDadosOcorrencia?idOcorrencia=' + $this.idOcorrencia, {
                    headers: $this.$api.getTokenComercial(),
                    params: '',
                    notLoading: true
                }).then(response => {
                    $this.idInstituicao = response.data.data.idInstituicao;
                    $this.url_cortesias = $this.getUrlCortesias();
                    $this.loading = false;
                })
            },
            gridRefreshed(data_ajax) {
                let $this = this;

                $this.refresh_grid = false;
                $this.NotLoading = false;
                $this.openCortesia($this.idCortesia_Selected);
            },
            reloadGrid() {
                let $this = this;
                $this.refresh_grid = true;
            },
            setTable(result) {
                $(result).each(function (index, element) {
                    if (element.dtUltimoLogin == null) {
                        element.dtUltimoLogin = '<i class="fas fa-times text-danger" style="font-size: 18px;"></i>';
                    } else {
                        element.dtUltimoLogin = '<i class="fas fa-check text-success" style="font-size: 18px;"></i>';
                    }
                });
                return result;
            },
            getUrlCortesias() {
                let $this = this;
                return process.env.VUE_APP_ROOT_COMERCIAL_API + '/GeracaoCortesia/GetModuloInstituicaoCortesias?' + 'idModulo=' + $this.idModulo + '&idInstituicao=' + $this.idInstituicao;
            },
            openCortesia(idCortesia, rowIndex) {
                let $this = this;

                $this.idCortesia_Selected = idCortesia;

                axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/GeracaoCortesia/GetCortesia?idCortesia=' + $this.idCortesia_Selected, {
                    headers: $this.$api.getTokenComercial(),
                    params: '',
                    notLoading: true
                }).then(response => {
                    $this.Cortesia = response.data.data;
                })
                this.selectedButtonIndices = Object.assign({}, this.selectedButtonIndices, { [rowIndex]: idCortesia });
            },
            action_cortesia() {
                let $this = this;

                if (this.setCortesiaCrud.idCortesia == 0) {
                    var request = { idOcorrencia: $this.idOcorrencia, idModulo: $this.idModulo, idPessoa: this.setCortesiaCrud.idPessoa, idInstituicao: this.setCortesiaCrud.idInstituicao };

                    axios.post(process.env.VUE_APP_ROOT_COMERCIAL_API + '/GeracaoCortesia/PostGerarCortesiaModuloInstituicaoPessoa', request, {
                        headers: this.$api.getTokenComercial()
                    }).then(response => {
                        $this.idCortesia_Selected = response.data.data;
                        $this.reloadGrid();

                    }).catch(error => {
                        var msg = 'Por favor, preencha todos os campos obrigatorios';
                        if (error.response) {
                            if (error.response.data.erros != '') {
                                msg = error.response.data.errors[0];
                            } else {
                                msg = error.response.data.msg;
                            }
                        }
                        $this.showErrorMessage = true;
                        $this.$toast.show('alert', msg, true);
                    });
                }

            },
            setActionCard(action) {
                this.$emit('setActionCard', action);
            },
            altera_vigencia() {
                let $this = this;

                var request = { idCortesia: $this.idCortesia_Selected, dtVigencia: $this.Cortesia.dtVigencia };

                axios.post(process.env.VUE_APP_ROOT_COMERCIAL_API + '/GeracaoCortesia/PostAlterarVigencia', request, {
                    headers: this.$api.getTokenComercial()
                }).then(response => {
                    //$this.action_cortesia($this.idCortesia_Selected, $this.Cortesia.idInstituicao, $this.idPessoa);
                }).catch(error => {
                    var msg = 'Por favor, preencha todos os campos obrigatorios';
                    if (error.response) {
                        if (error.response.data.erros != '') {
                            msg = error.response.data.errors[0];
                        } else {
                            msg = error.response.data.msg;
                        }
                    }
                    $this.showErrorMessage = true;
                    $this.$toast.show('alert', msg, true);
                });
            },
            altera_senha() {
                let $this = this;

                var request = { idCortesia: $this.idCortesia_Selected };

                axios.post(process.env.VUE_APP_ROOT_COMERCIAL_API + '/GeracaoCortesia/PostAlterarSenha', request, {
                    headers: this.$api.getTokenComercial()
                }).then(response => {
                    //$this.action_cortesia($this.idCortesia_Selected, $this.Cortesia.idInstituicao, $this.idPessoa);
                }).catch(error => {
                    var msg = 'Por favor, preencha todos os campos obrigatorios';
                    if (error.response) {
                        if (error.response.data.erros != '') {
                            msg = error.response.data.errors[0];
                        } else {
                            msg = error.response.data.msg;
                        }
                    }
                    $this.showErrorMessage = true;
                    $this.$toast.show('alert', msg, true);
                });
            }
        },
        mounted() {
            this.getDadosOcorrencia();
            this.updateSizeDinamic();
            window.addEventListener('resize', this.updateSizeDinamic);
        },
        watch: {
            idOcorrencia(newVal, oldVal) {
                this.getDadosOcorrencia();
                this.getOcorrencia();
            },
            idModulo(newVal, oldVal) {
            },
            filtro_text: function (newVal, oldVal) {
                let $this = this;

                $this.NotLoading = true;
                $this.filtro[0].value = newVal;
                $this.refresh_grid = true;
            },
        },
    }

</script>

<style scoped>
    .selected {
        background: rgb(52, 168, 83) !important;
        color: white !important;
    }

    .btn-visualiza-cortesia {
        color: rgb(52, 168, 83);
        background: white;
        padding: 7px 12px !important;
        border-radius: 5px;
        font-weight: 500;
        font-size: 13px;
        border: 1px solid rgb(52, 168, 83);
        margin-left: 10px;
    }

        .btn-visualiza-cortesia:hover {
            color: rgb(52, 168, 83);
            background: white;
            padding: 7px 12px !important;
            border-radius: 5px;
            font-weight: 500;
            font-size: 13px;
            border: 1px solid rgb(52, 168, 83);
            margin-left: 10px;
        }
</style>